<ngb-pagination [collectionSize]="collectionSize" [maxSize]="3" [ellipses]="true" [pageSize]="pageSize" [(page)]="page" (pageChange)="onPageChange($event)" aria-label="Custom pagination">
    <ng-template ngbPaginationPrevious>
        <img src="assets/images/common/slider/arr-left-disable.svg" alt="arrow-left">
    </ng-template>
    <ng-template ngbPaginationNext>
        <img src="assets/images/common/slider/arr-right-disable.svg" alt="arrow-right">
    </ng-template>
    <ng-template ngbPaginationNumber let-p>{{ p }}</ng-template>
</ngb-pagination>